import axios from 'axios';
import WindowWrapper from './windowWrapper';
import { userInfo } from '@apollo-internal/cache';
/*
 * Util function to make sure our page always has an access token
 *    When called it checks if we currently have a token, and if the token is valid.
 *      If not, attempts to use a refresh token
 *      If that fails, redirect the user to Login
 */
const TOKEN_FRAGMENT = 'token=';
const TOKEN_KEY = 'token';
const parseToken = location => {
  const hash = location.hash.substring(1);
  let hashParams = hash.split('&');
  const tokenParamIndex = hashParams.findIndex(hashParam => hashParam.includes(TOKEN_FRAGMENT));
  if (tokenParamIndex === -1) {
    return getToken();
  }

  setToken(hashParams[tokenParamIndex].substring(TOKEN_FRAGMENT.length));
  hashParams = hashParams.filter(param => !param.startsWith(TOKEN_FRAGMENT));

  location.hash = '';
  let uri = location.toString();
  uri += hashParams.join('&');
  if (uri.indexOf('#') + 1 === uri.length) {
    uri = uri.slice(0, -1);
  }
  window.history.replaceState({}, document.title, uri);

  return getToken();
};

export const getAccessToken = () => {
  const location = WindowWrapper.getLocation();

  if (!location.hash.includes(TOKEN_FRAGMENT)) {
    return getToken();
  }

  return parseToken(location);
};

export const fetchNewJwtToken = async () => {
  try {
    const response = await axios.get('/refresh_token', {
      baseURL: process.env.API_BASE_URL,
      headers: {
        Authorization: `Bearer ${getToken()}`
      }
    });

    return response.data;
  } catch (e) {
    return null;
  }
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const setToken = token => localStorage.setItem(TOKEN_KEY, token);

export const getLogoutUrl = () => {
  const token = getToken();

  if (token) {
    return `${process.env.API_BASE_URL}/sso/logout?token=${token}`;
  }

  const user = userInfo();
  const isUnauthorizedUser = !user;
  if (isUnauthorizedUser) {
    return `${process.env.API_BASE_URL}/sso/logout`;
  }

  return null;
};
